import { NgModule } from '@angular/core';
import { BackButtonComponent } from './back-button.component';



@NgModule({
  declarations: [BackButtonComponent],
  imports: [
  ],
  exports: [BackButtonComponent]
})
export class BackButtonModule { }
